export const alteraData = (data) => {
    var today = new Date(data);
    var value = today.toLocaleDateString("en-GB");
    return value;
  };
  
  export const truncateText = (text, maxLength) => {
    if (text.length > maxLength) {
      return text.substring(0, maxLength) + "...";
    }
    return text;
  };
  
  export const trimSlashes = (str) => {
    str = str.startsWith("/") ? str.substr(1) : str;
    str = str.endsWith("/") ? str.substr(0, str.length - 1) : str;
    return str;
  };
  